import { useState } from "react";
import { Link, useLocation } from "wouter";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

const MIN_LEN = 8;

export default function RegisterPage() {
  const [, setLocation] = useLocation();
  const { register } = useAuth();
  const [loginField, setLoginField] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    if (password.length < MIN_LEN) {
      setError(`Пароль не короче ${MIN_LEN} символов`);
      return;
    }
    setPending(true);
    try {
      await register(loginField, password);
      setLocation("/");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Ошибка регистрации");
    } finally {
      setPending(false);
    }
  }

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{ background: "var(--background, #0f1419)" }}
    >
      <Card className="w-full max-w-md border-[var(--sidebar-border)]" style={{ background: "var(--card)" }}>
        <CardHeader>
          <CardTitle>Регистрация</CardTitle>
          <CardDescription>Только для логинов из списка приглашённых (admin или email редактора)</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={onSubmit} className="space-y-4">
            {error ? (
              <div className="text-sm text-red-600 dark:text-red-400" role="alert">
                {error}
              </div>
            ) : null}
            <div className="space-y-2">
              <Label htmlFor="reg-login">Логин (admin или email)</Label>
              <Input
                id="reg-login"
                autoComplete="username"
                value={loginField}
                onChange={(e) => setLoginField(e.target.value)}
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="reg-password">Пароль (мин. {MIN_LEN} символов)</Label>
              <Input
                id="reg-password"
                type="password"
                autoComplete="new-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={MIN_LEN}
              />
            </div>
            <Button type="submit" className="w-full" disabled={pending}>
              {pending ? "Регистрация…" : "Зарегистрироваться"}
            </Button>
            <p className="text-sm text-muted-foreground text-center">
              <Link href="/login" className="underline hover:text-foreground">
                Уже есть аккаунт — войти
              </Link>
            </p>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
